import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { GetStockProductModel } from "features/stock-ordering/core/domain/get-stock-product.model";
import { UserNotificationModel } from "features/stock-ordering/core/domain/user-notification.model";
import {
  stockUserNotificationResponse,
  stockUserNotificationRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum StockUserNotificationState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: StockUserNotificationState;
  message: string;
  data: UserNotificationModel | undefined;
}

const initialState: InitialState = {
  status: StockUserNotificationState.initial,
  message: "",
  data: undefined,
};

export const stockUserNotification = createAsyncThunk(
  "stockUserNotification",
  async (_, { rejectWithValue }) => {
    try {
      const response: stockUserNotificationResponse =
        await stockUserNotificationRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const stockUserNotificationSlice = createSlice({
  name: "stockUserNotification",
  initialState,
  reducers: {
    resetstockUserNotificationStatus: (state) => {
      state.status = StockUserNotificationState.initial;
      state.data = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(stockUserNotification.pending, (state) => {
        state.status = StockUserNotificationState.inProgress;
      })
      .addCase(stockUserNotification.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = StockUserNotificationState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(stockUserNotification.rejected, (state, action) => {
        state.status = StockUserNotificationState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectStockUserNotification = (state: RootState) =>
  state.stockUserNotification;

export const { resetstockUserNotificationStatus } =
  stockUserNotificationSlice.actions;
export default stockUserNotificationSlice.reducer;
